/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

export default function makeSearchParams(params = []) {
  if (!Array.isArray(params) || params.length === 0) {
    return '';
  }

  const result = params.reduce((accum, current) => {
    return accum += `${current}&`;
  }, '?');

  return result.substring(0, result.length - 1);
}
